import { isInIframe } from '@genoa/utils'

import { useIsEmbed } from './use-is-embed'

export const useIsInEmbedFrame = () => {
  const isEmbed = useIsEmbed()

  return isInIframe() && isEmbed
}
